module.exports = __webpack_public_path__ + "static/media/halborn.ebc75064.svg";